<template>
  <div class="row">
    <div class="col-md-12">
      <h3 class="title">{{ $t('files')}}</h3>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <!-- icon prop for icon button -->
        <p-button class="btn btn-primary pull-right" @click="handleCreateModal">
          <i class="fa fa-plus"></i> {{ $t('upload_file') }}
        </p-button>
        <!-- <div class="category">Category List</div> -->
      </div>
      <div class="card-body row">
        <div class="col-md-6">
          <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input
              class="input-sm"
              :placeholder="$t('search')"
              v-model="searchQuery"
              addon-right-icon="nc-icon nc-zoom-split"
            ></fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table
            v-loading="loading"
            :element-loading-text="$t('loading_data')+'...'"
            class="table-striped"
            :data="queriedData"
            border
            style="width: 100%"
          >
            <el-table-column :label="$t('image_preview')">
              <template slot-scope="props">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 200px; height: 200px"
                    :src="props.row.file_data.thumbnail.full_url"
                    :preview-src-list="[props.row.file_data.full_url, props.row.file_data.thumbnail.full_url]"
                  ></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Size">
              <template slot-scope="props">
                <span>{{ props.row.file_data.file_size }}</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" class-name="td-actions" :label="$t('actions')">
              <template slot-scope="props">
                <p-button
                  type="primary"
                  size="sm"
                  icon
                  v-clipboard:copy="props.row.file_data.full_url"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onCopyError"
                >
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button
                  type="danger"
                  size="sm"
                  icon
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-times"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-primary">
          <p class="category">{{ $t('showing')}} {{from + 1}} {{ $t('to') }} {{to}} {{$t('of')}} {{total}} {{$t('entries')}}</p>
        </div>
        <div class="col-sm-6">
          <p-pagination
            class="pull-right"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
          ></p-pagination>
        </div>
      </div>
    </div>

    <!-- Edit Modal -->
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{$t('upload_file')}}</h4>
      <ValidationObserver ref="uploadForm">
        <form>
          <el-upload
            class="upload-demo"
            ref="upload"
            action="http://localhost:8000/api/files"
            :headers="headers"
            :auto-upload="false"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            multiple
            :file-list="fileList"
          >
            <el-button slot="trigger" size="small" type="primary">{{$t('select_file')}}</el-button>
            <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div>
          </el-upload>
        </form>
      </ValidationObserver>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal">{{ $t('cancel') }}</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="primary" link @click="submitUpload">{{ $t('save') }}</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Modal from "src/components/UIComponents/Modal.vue";
import { Message } from "element-ui";

import { getToken } from "@/util/auth";
import Resource from "@/util/Api/resource.js";
const FileResource = new Resource("files");

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  components: {
    PPagination,
    Modal
  },
  computed: {
    pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length;
        return this.pagedData;
      }
      let result = this.tableData.filter(row => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString();
          rowValue = rowValue.toLowerCase();
          this.searchQuery = this.searchQuery.toLowerCase();
          if (rowValue.includes && rowValue.includes(this.searchQuery)) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    }
  },
  data() {
    return {
      fileList: [],
      headers: {
        Authorization: "Bearer " + getToken()
      },
      modals: {
        classic: false
      },
      loading: false,
      updateState: false,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["file_name", "full_url", "file_size", "created_at"],
      tableColumns: [
        {
          prop: "file_name",
          label: this.$t("name")
        },
        {
          prop: "file_size",
          label: this.$t("size")
        },
        {
          prop: "created_at",
          label: this.$t("created")
        }
      ],
      tableData: [],
      files: [],
      form: {
        name: "",
        category_id: null
      }
    };
  },
  methods: {
    onCopy() {
      this.showAlertMessage("URL copied to clipboard", "success");
    },
    onCopyError() {
      this.showAlertMessage("Failed to copy URL", "error");
    },
    resetForm() {},
    handleCreateModal() {
      this.resetForm();
      this.updateState = false;
      this.modals.classic = true;
    },
    handleCloseModal() {
      this.modals.classic = false;
      this.resetForm();
      this.updateState = false;
    },
    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },
    handleDelete(index, row) {
      this.$confirm("Are you sure you want to delete this File?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        cancelButtonClass: "btn-danger",
        confirmButtonClass: "btn-primary",
        type: "warning"
      })
        .then(() => {
          let indexToDelete = this.tableData.findIndex(
            tableRow => tableRow.id === row.id
          );
          if (indexToDelete >= 0) {
            this.form = row;
            FileResource.destroy(this.form.id)
              .then(response => {
                this.tableData.splice(indexToDelete, 1);
                this.showAlertMessage(response.message, "success");
              })
              .catch(error => {});
          }
        })
        .catch(() => {});
    },
    async getFiles() {
      this.loading = true;
      await FileResource.list({})
        .then(response => {
          this.loading = false;
          this.tableData = response.data;
          this.files = response.data;
        })
        .catch(error => {
          this.loading = false;
          // this.showAlertMessage(error.message, "success");
        });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleUploadSuccess(res, file) {
      this.modals.classic = false;
      this.showAlertMessage(res.message, "success");
      this.$refs.upload.clearFiles();
      this.getFiles();
    },
    handleUploadError(err, file) {
      this.showAlertMessage("Error uploading application", "error");
    }
  },
  created() {
    this.getFiles();
  }
};
</script>
<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
</style>
